export default __webpack_public_path__ + "static/160-935b9985b1aeafdc716764d6c49873a0.jpg";